
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Popup } from 'vant';

Vue.use(Popup);
@Component
export default class TipsPop extends Vue {
    @Prop() show!: boolean;
    @Prop() msg?: string;
    @Prop() title?: string;

    close() {
        this.$emit('close');
    }
}
